/**
 * @prettier
 */

import React from 'react';
import { ButtonV2 } from '@zola/zola-ui';
import FeatureFlags from '../../../../../util/featureFlags';
import Layout from '../Layout/Layout';
import PhotoUpload from '../PhotoUpload/PhotoUpload';
import { STEPS } from '../constants/steps';

import styles from './styles.module.less';

const PhotoCrop = ({
  isMulti,
  form,
  goToStep,
  template,
  sampleNotCustomizable,
  updateForm,
  multiPreviewState,
}) => {
  return (
    <div className={styles.cropBox}>
      <Layout.Header>Crop Photo</Layout.Header>
      <PhotoUpload.Crop
        activePreview={multiPreviewState.activePreview}
        form={form}
        page={template && template.pages[0]}
        updateForm={updateForm}
      />
      <div className={styles.saveBox}>
        <ButtonV2
          disabled={!template}
          onClick={() => {
            if (isMulti) {
              goToStep(STEPS.MULTI_UPLOAD_HELP);
            } else if (
              FeatureFlags.get('invitesSingleSampleCustomizeStep') &&
              !sampleNotCustomizable
            ) {
              goToStep(STEPS.CUSTOMIZATION);
            } else {
              goToStep(STEPS.WEDDING_DETAILS_FORM);
            }
          }}
        >
          {template ? 'Save' : 'Loading...'}
        </ButtonV2>
      </div>
    </div>
  );
};

export default PhotoCrop;



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/SingleSampleFlowSteps/PhotoCrop.jsx